import { RadioButtonWithLabelGroupWidget } from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { ReactActionDialogBodyProps } from '../../../commonInfra/dialogs/ReactActionDialog';
import { DatabaseForUngrouping } from '../../actions/spaces/UngroupDatabasesAction';


export type UngroupDatabasesDialogBodyProps = { readonly database: DatabaseForUngrouping };
export type UngroupDatabasesDialogState = { readonly copyMetadataToUngroupedItems: boolean };
export type PropsForConfirmActionDialogBody = ReactActionDialogBodyProps<UngroupDatabasesDialogBodyProps, UngroupDatabasesDialogState>;

export function UngroupDatabasesDialogBody(props: PropsForConfirmActionDialogBody): JSX.Element {

  const setCopyMetadataBoolean = React.useCallback(
    (value: boolean) => props.updateDialogState({ copyMetadataToUngroupedItems: value }),
    // This deps array was noncompliant before we enabled the lint rule. If you’re here, please consider fixing it! See TFS 1257824
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.updateDialogState]
  );

  const selectedRadioButtonIndex = props.dialogState.copyMetadataToUngroupedItems ? 0 : 1;

  return (
    <div>
      <p>{Messages.ungroupDatabases_dialogBodyHeader_metadata()}</p>
      <RadioButtonWithLabelGroupWidget
        buttonList={[
          {
            label: Messages.ungroupDatabases_copyMetadataToUngroupedItems_true(),
            testId: 'ungroup-radio-button-copy-metadata-true',
            value: true,
          },
          {
            label: Messages.ungroupDatabases_copyMetadataToUngroupedItems_false(),
            testId: 'ungroup-radio-button-copy-metadata-false',
            value: false,
          },
        ]}
        checkedIndex={selectedRadioButtonIndex}
        handleChange={setCopyMetadataBoolean}
      />
    </div>
  );
}
